import { render, staticRenderFns } from "./AdminSettingWorkflowComments.vue?vue&type=template&id=08a62b8a&scoped=true&"
import script from "./AdminSettingWorkflowComments.vue?vue&type=script&lang=js&"
export * from "./AdminSettingWorkflowComments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08a62b8a",
  null
  
)

export default component.exports